import { Controller } from "@hotwired/stimulus"
import { armStartIntent } from "../lib/speech/start_intent"

// The Conversation-mode entry button. Arming happens as the form submits, so
// the session page that the server redirects to knows this arrival was the
// staff member choosing to record — the only arrival that starts listening
// without another tap. The intent is armed for this form's own destination
// (its action, the respondent's sessions path) and nowhere else.
export default class extends Controller<HTMLFormElement> {
  arm() {
    const action = this.element.getAttribute("action") || ""
    armStartIntent(new URL(action, window.location.origin).pathname)
  }
}
